// Export API client utilities
export { apiClient, createApiClient, REPEATED_QUERY_PARAMS } from './apiClient';
export { apiFetch, getApiAuthHeaders, getApiBaseUrl } from './apiRequest';
export { createLazyQuery } from './createLazyQuery';
export { fetchAllPages } from './fetchAllPages';
export type { ListWindow } from './fetchAllPages';
export type { InternalAxiosRequestConfigMeta } from './types';
export { createQueryClient, queryClient } from './queryClient';
export {
  getApiErrorMessage,
  getApiErrorStatus,
  readApiErrorMessage,
  registerUnauthorizedHandler,
} from './errorHandler';
export { getRecordIssues, isModelIssue } from './predicateIssue';
export type { PredicateIssue, PredicateIssueType } from './predicateIssue';

// Export API tags for cache invalidation
export const API_TAGS = {
  RECORDS: 'Records',
  DIALOGS: 'Dialogs',
  USERS: 'Users',
  STATISTICS: 'Statistics',
  RULES: 'Rules',
  ASSESSMENTS: 'Assessments',
  ATTRIBUTES: 'Attributes',
  ATTRIBUTE_GROUPS: 'AttributeGroups',
  CHECKLISTS: 'Checklists',
  ROLES: 'Roles',
  PROFILE: 'Profile',
  USER_GROUPS: 'UserGroups',
  PREDICATES: 'Predicates',
  DASHBOARDS: 'Dashboards',
  CONTENT: 'Content',
  TERMS: 'Terms',
  STOP_WORDS: 'StopWords',
  SETTINGS: 'Settings',
  SYSTEM_PRESETS: 'SystemPresets',
  KNOWLEDGE: 'Knowledge',
  KNOWLEDGE_SOURCES: 'KnowledgeSources',
  SAMPLES: 'Samples',
  JOBS: 'Jobs',
  SEARCH: 'Search',
  THEMES: 'Themes',
  EXPERT_REPORTS: 'ExpertReports',
  KNOWLEDGE_SETS: 'KnowledgeSets',
  AI_AGENT_CHATS: 'AiAgentChats',
  COACHING: 'Coaching',
  ANONYMIZER_CONFIG: 'AnonymizerConfig',
  EMPLOYEES: 'Employees',
  EMPLOYEE_GROUPS: 'EmployeeGroups',
  INTEGRATIONS: 'Integrations',
  RENESSANS_DASHBOARDS: 'RenessansDashboards',
  USER_URL_LOGS: 'UserUrlLogs',
  STRATEGIST: 'Strategist',
  BETA_FEATURES: 'BetaFeatures',
  DOWNLOAD_TEMPLATES: 'DownloadTemplates',
  PHRASES: 'Phrases',
} as const;

// Export types for API tags
export type ApiTag = keyof typeof API_TAGS;
